import { PageInPhoneFrame } from "@/components/ui/PageInPhoneFrame/PageInPhoneFrame";
import { env } from "@/env";
import { routes } from "@/shared/routes";

export function QuestionnaireAssetFrame() {
  return (
    <PageInPhoneFrame src={`${env.VITE_APP_URL}${routes.assetQuestionnaire}`} />
  );
}
